import React, { Component } from 'react';

class ColorsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            color: '#ff7657',
            playerColor: '#e09a8a',
            backgroundColor: '#ffffff',
            secondaryBackgroundColor: '#ecf2ff',
        };

        this.onChangeMain = this.onChangeMain.bind(this);
        this.onChangePlayerColor = this.onChangePlayerColor.bind(this);
        this.onChangeBackground = this.onChangeBackground.bind(this);
        this.onChangeSecondaryBackground = this.onChangeSecondaryBackground.bind(this);
    }

    onChangePlayerColor(e) {
        let color = e.target.value;
        this.setState({
            playerColor: color
        });

        document.documentElement.style
            .setProperty('--analogous-color', color);
    }

    onChangeMain(e) {
        let color = e.target.value;
        this.setState({
            color: color
        });

        document.documentElement.style
            .setProperty('--color-2', color);
        document.documentElement.style
            .setProperty('--color-1', color);
        document.documentElement.style
            .setProperty('--color-3', color);

        document.documentElement.style
            .setProperty('--logo-background-color', color);

    }

    onChangeBackground(e) {
        let color = e.target.value;
        this.setState({
            backgroundColor: color
        });

        document.documentElement.style
            .setProperty('--background-color', color);
    }

    onChangeSecondaryBackground(e) {
        let color = e.target.value;
        this.setState({
            secondaryBackgroundColor: color
        });

        const navigator = document.querySelector('.navigator');
        navigator.style.setProperty('--negative-space', color);

        const profileContainer = document.querySelector('.profile-container');
        profileContainer.style.setProperty('--negative-space', color);
    }

    render() {
        return (
            <div>
              <div>
                Main:
                <input type="color" value={this.state.color} onChange={this.onChangeMain}/>
              </div>
              <div>
                Player:
                <input type="color" value={this.state.playerColor} onChange={this.onChangePlayerColor}/>
              </div>
              <div>
                Background:
                <input type="color" value={this.state.backgroundColor} onChange={this.onChangeBackground}/>
              </div>
              <div>
                Secondary:
                <input type="color" value={this.state.secondaryBackgroundColor} onChange={this.onChangeSecondaryBackground}/>
              </div>
            </div>
        );
    }
}

export default ColorsComponent;
